import { render, staticRenderFns } from "./UrlParameters.vue?vue&type=template&id=a6f3c8f2"
import script from "./UrlParameters.vue?vue&type=script&lang=js"
export * from "./UrlParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports